import { Fragment } from 'react';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../..';

type Props = StructuredContentDocument<{
  children: StructuredContentDocument;
}>;

export const DocumentStructuredContent = ({ props }: Props) => {
  return (
    <>
      {[props.children].flat().map((child, idx) => {
        if (typeof child === 'string') {
          return <Fragment key={idx}>{child}</Fragment>;
        }

        if (child) {
          return <StructuredContentRenderer doc={child} key={idx} />;
        }
      })}
    </>
  );
};
